export default function rewriteImageUrl(url: string) {
  return url.replace('https://storage.yandexcloud.net/asar-studio-uppy', 'https://cdn.asar.studio')
}
